import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { Icon, Text } from '@navinc/base-react-components'
import { usePartnerEnabledSettings } from '../pages/settings/partner-enabled-settings'
import { Logout } from './logout'

const StyledIcon = styled(Icon).attrs(
  () =>
    ({ theme }) =>
      theme.navSecondary
)`
  max-width: 20px;
  max-height: 20px;
`

const AccountSettings = styled.ul`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${({ theme }) => theme.navSecondary};
  padding: 16px 0;
`

const AccountItem = styled(Text)`
  padding: 8px 16px;
  font-weight: 700;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  color: ${({ theme }) => theme.navSecondary};
  display: grid;
  grid-template-columns: 24px 1fr auto;
  gap: 16px;
  align-items: center;
  align-content: center;

  & > ${StyledIcon} {
    margin-right: 16px;
  }

  &.is-active,
  &:focus {
    font-weight: 0;
    color: ${({ theme }) => theme.navPrimary400};
    background: ${({ theme }) =>
      `${theme.navPrimary300} radial-gradient(circle, transparent 1%, ${theme.navPrimary700} 1%) center/15000%`};
  }

  &:hover {
    color: inherit;
    color: ${({ theme }) => theme.navSecondary};
    background-color: ${({ theme }) => theme.navPrimary400};
    transition: ease-out background 0.4s;
  }
`

const StyledLogout = styled(Logout)`
  display: flex;
  padding: 8px 16px;
  border-radius: 24px;
  color: ${({ theme }) => theme.navNeutral400};

  & > ${StyledIcon} {
    margin-right: 24px;
  }

  &:hover,
  &:focus,
  &.is-active {
    background-color: ${({ theme }) => theme.navNeutral100};
  }
`

const StyledNavLink = styled(AccountItem).attrs(() => ({ as: NavLink }))``

export const UserSettings = ({ onNavigate }) => {
  const { partnerHasLogout } = usePartnerEnabledSettings()

  return (
    <AccountSettings>
      <li data-testid="account-settings:settings-link">
        <StyledNavLink activeClassName="is-active" to="/partner/settings" onClick={onNavigate}>
          <StyledIcon name="tech/settings" />
          Settings
        </StyledNavLink>
      </li>
      <li data-testid="account-settings:contact-us-link">
        <StyledNavLink activeClassName="is-active" to="/partner/contact" onClick={onNavigate}>
          <StyledIcon name="people/profile" />
          Contact us
        </StyledNavLink>
      </li>
      {partnerHasLogout() && (
        <li data-testid="account-settings:log-out-link">
          <StyledLogout>
            <StyledIcon name="actions/logout" onClick={onNavigate} />
            Log out
          </StyledLogout>
        </li>
      )}
    </AccountSettings>
  )
}
